import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAssessment } from '../../store/actions/AssessmentActions';
import McqCanvas from './McqCanvas';

const Mcqs = () => {
  const { assessment_id, mcq_id } = useParams();
  const dispatch = useDispatch();
  const { mcqIds } = useSelector(state => state.assessment);
  const { test_id } = useSelector(state => state.invite);

  useEffect(() => {
    const loadAssessment = async () => {
      if (assessment_id && mcqIds.length === 0) {
        await dispatch(fetchAssessment(assessment_id));
      }
      sessionStorage.setItem('assessment_id', assessment_id);
      sessionStorage.setItem('test_id', test_id);
    };
    loadAssessment();
  }, [assessment_id, mcqIds.length, dispatch, test_id]);

  return (
    <>
      <McqCanvas initialMcqId={mcq_id} />
    </>
  );
};

export default Mcqs;
